import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable()
export class RequestService {
    deleted: number[] = [];

    constructor(private api: ApiService) {

    }

    async saveTurnoutRequest(request: any, runId: number) {
        return this.api.postWithAuth(this.api.endpoints.requests + '/SaveTurnoutRequest' + '?runId=' + runId, request);
    }

    async getEntryChangeRequestsByOrganization(organizationId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.requests + '/GetChangeRequestsByOrganization?organizationId=' + organizationId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    async getUserReleaseRequests(accountId: number, organizationId?: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.requests
                    + '/GetUserReleaseRequests?accountId=' + accountId + '&organizationId=' + organizationId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    async getRequest(id: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.requests + '/GetRequest?id=' + id)
                .then(data => resolve(data), error => reject(error));
        });
    }
    
    async searchRequests(searchOptions) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.requests + '/SearchRequests', searchOptions)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/request.service.ts